import axios from 'axios';
import { getAuthHeaders } from '../Auth';
import exportedConfig from '../config';

interface GenerateLogoV4Params {
    prompt?: string;
    tagLine?: string;
    businessName: string;
    industry?: string;
    businessDescription?: string;
    style?: string;
    mediaType?: string;
    priority?: string;
    culture?: string;
    signal: AbortSignal;
}

interface GenerateLogoV4Response {
    imageUrl: string;
    prompt: string;
}

export const postGenerateLogoV4 = async ({
    prompt,
    tagLine,
    businessName,
    industry,
    businessDescription,
    style,
    mediaType,
    priority,
    culture,
    signal,
}: GenerateLogoV4Params): Promise<GenerateLogoV4Response> => {
    try {
        const headers = await getAuthHeaders();
        const response = await axios.post(
            `${exportedConfig.backendServiceUrl}/api/v4/inspiration:generateLogo`,
            {
                prompt,
                tagLine,
                businessName,
                industry,
                businessDescription,
                style,
                mediaType,
                priority,
                culture,
            },
            {
                signal,
                headers,
            },
        );

        if (!response.data) {
            throw new Error('Empty response from API');
        }

        if (!response.data.imageUrl) {
            console.error('API Response:', response.data);
            throw new Error('API response missing imageUrl field');
        }

        return {
            imageUrl: response.data.imageUrl,
            prompt: response.data.prompt || '',
        };
    } catch (error) {
        if (axios.isAxiosError(error)) {
            console.error('API Error:', error.response?.data || error.message);
            throw new Error(`API request failed: ${error.response?.data?.message || error.message}`);
        }
        console.error('Error generating image:', error);
        throw error;
    }
};
